module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-9"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.selectedProfileField),
      expression: "selectedProfileField"
    }],
    staticClass: "form-control",
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.selectedProfileField = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', {
    domProps: {
      "value": null
    }
  }, [_vm._v(" Select field...")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "all-fields"
    }
  }, [_vm._v(" All fields")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "all-fields-calculations"
    }
  }, [_vm._v(" All fields and calculations")]), _vm._v(" "), _vm._l((_vm.profileFields), function(option, oi) {
    return (option.description) ? _c('option', {
      attrs: {
        "disabled": option.type === 'text-entry'
      },
      domProps: {
        "value": option
      }
    }, [_vm._v("\n          " + _vm._s(_vm._f("striphtml")(option.description)) + "\n        ")]) : _vm._e()
  })], 2)]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3 mb-2"
  }, [_c('button', {
    staticClass: "btn green",
    on: {
      "click": _vm.addFieldFromProfile
    }
  }, [_vm._v("Add")])])]), _vm._v(" "), _c('hr')])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('h5', [_vm._v("Add field from "), _c('strong', [_vm._v("Profile Form")]), _vm._v(" to "), _c('strong', [_vm._v("Referral Form")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-f7796f84","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/formbuilder/referral/ReferralAddFieldFromProfile.vue
// module id = 1760
// module chunks = 1